import * as React from "react";
import ViewProductsView from "../presentation/view-products";
import axios from 'axios';
const _ = require('lodash');
import moment from "moment";
import CONSTS from "../consts";
export default class ViewProducts extends React.Component {
    constructor(props) {
        super(props);
        this.getSuggestionQuery = (oDataPath, type = "", subType = "", category = "", SKU = "") => {
            let suggestionQuery = `${oDataPath}Products/ConnectMobile.Web.Filter` +
                `(searchText='',` +
                `container='',` +
                `size='',` +
                `percentAlcohol='',` +
                `country='',` +
                `supplier='',` +
                `searchCategory='${category}',` +
                `type='${type}',` +
                `subType='${subType}',` +
                `subSubType='',` +
                `colour='',` +
                `vintage='',` +
                `sugar='',` +
                `similar='${SKU}')` +
                `?$count=true&$orderby=Relevance+desc&$top=4`;
            return suggestionQuery;
        };
        this.getProduct = () => {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Products(${this.props.id})?$expand=Events($filter=StartDate ge ${moment().format("YYYY-MM-DD")}T00:00:00.000Z),Agent`;
            axios.get(query)
                .then((response) => {
                let product = {};
                for (let atr in response.data) {
                    product[atr] = typeof response.data[atr] === 'string' ?
                        response.data[atr].toLowerCase().trim() : response.data[atr];
                }
                this.setState({
                    product: _.omit(product, ['Events']),
                    events: product.Events,
                    loadingProducts: false,
                });
                let suggestionQuery = this.getSuggestionQuery(oDataPath, response.data.Type.trim(), response.data.SubType.trim(), response.data.SearchCategory.trim(), response.data.SKU.trim());
                return axios.get(suggestionQuery);
            })
                .then((response) => {
                if (response.data.value.length > 0) {
                    this.setState({
                        suggestions: response.data.value,
                        loadingSuggestions: false,
                    });
                }
            });
        };
        this.state = {
            product: {},
            suggestions: [],
            events: [],
            loadingProducts: true,
            loadingSuggestions: true,
            hasProductImage: false,
            hasAgentImage1: false,
            hasAgentImage2: false,
            hasBrandLogo: false
        };
    }
    componentDidMount() {
        this.getProduct();
    }
    render() {
        return (React.createElement(ViewProductsView, Object.assign({}, this.state)));
    }
}
;
//# sourceMappingURL=view-products.js.map